import { render, staticRenderFns } from "./registerDraw.vue?vue&type=template&id=8776c334&scoped=true"
import script from "./registerDraw.vue?vue&type=script&lang=js"
export * from "./registerDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8776c334",
  null
  
)

export default component.exports